var _g, _defs, _defs2, _defs3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDep2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 118,
  height: 96,
  viewBox: "0 0 118 96",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#dep2_svg__filter0_ddi_4438_2775)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M50 44C50 43.77 50.04 43.55 50.1 43.33C50.73 45.59 54.46 47.33 59 47.33C63.54 47.33 67.27 45.59 67.9 43.33C67.96 43.55 68 43.77 68 44C68 46.58 63.97 48.67 59 48.67C54.03 48.67 50 46.58 50 44ZM59 43.33C63.97 43.33 68 41.24 68 38.66C68 38.43 67.96 38.21 67.9 37.99C67.27 40.25 63.54 41.99 59 41.99C54.46 41.99 50.73 40.25 50.1 37.99C50.04 38.21 50 38.43 50 38.66C50 41.24 54.03 43.33 59 43.33ZM59 51.33C63.97 51.33 68 49.24 68 46.66C68 46.43 67.96 46.21 67.9 45.99C67.27 48.25 63.54 49.99 59 49.99C54.46 49.99 50.73 48.25 50.1 45.99C50.04 46.21 50 46.43 50 46.66C50 49.24 54.03 51.33 59 51.33ZM59 46C63.97 46 68 43.91 68 41.33C68 41.1 67.96 40.88 67.9 40.66C67.27 42.92 63.54 44.66 59 44.66C54.46 44.66 50.73 42.92 50.1 40.66C50.04 40.88 50 41.1 50 41.33C50 43.91 54.03 46 59 46ZM59 54C63.97 54 68 51.91 68 49.33C68 49.1 67.96 48.88 67.9 48.66C67.27 50.92 63.54 52.66 59 52.66C54.46 52.66 50.73 50.92 50.1 48.66C50.04 48.88 50 49.1 50 49.33C50 51.91 54.03 54 59 54ZM59 59.33C63.97 59.33 68 57.24 68 54.66C68 54.43 67.96 54.21 67.9 53.99C67.27 56.25 63.54 57.99 59 57.99C54.46 57.99 50.73 56.25 50.1 53.99C50.04 54.21 50 54.43 50 54.66C50 57.24 54.03 59.33 59 59.33ZM59 56.66C63.97 56.66 68 54.57 68 51.99C68 51.76 67.96 51.54 67.9 51.32C67.27 53.58 63.54 55.32 59 55.32C54.46 55.32 50.73 53.58 50.1 51.32C50.04 51.54 50 51.76 50 51.99C50 54.57 54.03 56.66 59 56.66ZM59 40.66C63.97 40.66 68 38.57 68 35.99C68 35.76 67.96 35.54 67.9 35.32C67.27 37.58 63.54 39.32 59 39.32C54.46 39.32 50.73 37.58 50.1 35.32C50.04 35.54 50 35.76 50 35.99C50 38.57 54.03 40.66 59 40.66ZM59 27.33C63.97 27.33 68 25.24 68 22.66C68 20.08 63.97 18 59 18C54.03 18 50 20.09 50 22.67C50 25.25 54.03 27.34 59 27.34V27.33ZM59 32.66C63.97 32.66 68 30.57 68 27.99C68 27.76 67.96 27.54 67.9 27.32C67.27 29.58 63.54 31.32 59 31.32C54.46 31.32 50.73 29.58 50.1 27.32C50.04 27.54 50 27.76 50 27.99C50 30.57 54.03 32.66 59 32.66ZM59 29.99C63.97 29.99 68 27.9 68 25.32C68 25.09 67.96 24.87 67.9 24.65C67.27 26.91 63.54 28.65 59 28.65C54.46 28.65 50.73 26.91 50.1 24.65C50.04 24.87 50 25.09 50 25.32C50 27.9 54.03 29.99 59 29.99ZM59 61.99C63.97 61.99 68 59.9 68 57.32C68 57.09 67.96 56.87 67.9 56.65C67.27 58.91 63.54 60.65 59 60.65C54.46 60.65 50.73 58.91 50.1 56.65C50.04 56.87 50 57.09 50 57.32C50 59.9 54.03 61.99 59 61.99ZM59 35.32C63.97 35.32 68 33.23 68 30.65C68 30.42 67.96 30.2 67.9 29.98C67.27 32.24 63.54 33.98 59 33.98C54.46 33.98 50.73 32.24 50.1 29.98C50.04 30.2 50 30.42 50 30.65C50 33.23 54.03 35.32 59 35.32ZM59 37.99C63.97 37.99 68 35.9 68 33.32C68 33.09 67.96 32.87 67.9 32.65C67.27 34.91 63.54 36.65 59 36.65C54.46 36.65 50.73 34.91 50.1 32.65C50.04 32.87 50 33.09 50 33.32C50 35.9 54.03 37.99 59 37.99ZM79 51.32C74.47 51.32 70.73 49.58 70.1 47.32C70.04 47.54 70 47.76 70 47.99C70 50.57 74.03 52.66 79 52.66C83.97 52.66 88 50.57 88 47.99C88 47.76 87.96 47.54 87.9 47.32C87.27 49.58 83.54 51.32 79 51.32ZM79 53.99C74.47 53.99 70.73 52.25 70.1 49.99C70.04 50.21 70 50.43 70 50.66C70 53.24 74.03 55.33 79 55.33C83.97 55.33 88 53.24 88 50.66C88 50.43 87.96 50.21 87.9 49.99C87.27 52.25 83.54 53.99 79 53.99ZM79 40.66C74.47 40.66 70.73 38.92 70.1 36.66C70.04 36.88 70 37.1 70 37.33C70 39.91 74.03 42 79 42C83.97 42 88 39.91 88 37.33C88 37.1 87.96 36.88 87.9 36.66C87.27 38.92 83.54 40.66 79 40.66ZM79 39.33C83.97 39.33 88 37.24 88 34.66C88 32.08 83.97 29.99 79 29.99C74.03 29.99 70 32.08 70 34.66C70 37.24 74.03 39.33 79 39.33ZM79 46C74.47 46 70.73 44.26 70.1 42C70.04 42.22 70 42.44 70 42.67C70 45.25 74.03 47.34 79 47.34C83.97 47.34 88 45.25 88 42.67C88 42.44 87.96 42.22 87.9 42C87.27 44.26 83.54 46 79 46ZM79 48.67C74.47 48.67 70.73 46.93 70.1 44.67C70.04 44.89 70 45.11 70 45.34C70 47.92 74.03 50.01 79 50.01C83.97 50.01 88 47.92 88 45.34C88 45.11 87.96 44.89 87.9 44.67C87.27 46.93 83.54 48.67 79 48.67ZM79 43.34C74.47 43.34 70.73 41.6 70.1 39.34C70.04 39.56 70 39.78 70 40.01C70 42.59 74.03 44.68 79 44.68C83.97 44.68 88 42.59 88 40.01C88 39.78 87.96 39.56 87.9 39.34C87.27 41.6 83.54 43.34 79 43.34ZM79 56.67C74.47 56.67 70.73 54.93 70.1 52.67C70.04 52.89 70 53.11 70 53.34C70 55.92 74.03 58.01 79 58.01C83.97 58.01 88 55.92 88 53.34C88 53.11 87.96 52.89 87.9 52.67C87.27 54.93 83.54 56.67 79 56.67ZM39 35.33C34.03 35.33 30 37.42 30 40C30 42.58 34.03 44.67 39 44.67C43.97 44.67 48 42.58 48 40C48 37.42 43.97 35.33 39 35.33ZM39 51.33C34.47 51.33 30.73 49.59 30.1 47.33C30.04 47.55 30 47.77 30 48C30 50.58 34.03 52.67 39 52.67C43.97 52.67 48 50.58 48 48C48 47.77 47.96 47.55 47.9 47.33C47.27 49.59 43.54 51.33 39 51.33ZM39 54C34.47 54 30.73 52.26 30.1 50C30.04 50.22 30 50.44 30 50.67C30 53.25 34.03 55.34 39 55.34C43.97 55.34 48 53.25 48 50.67C48 50.44 47.96 50.22 47.9 50C47.27 52.26 43.54 54 39 54ZM39 56.67C34.47 56.67 30.73 54.93 30.1 52.67C30.04 52.89 30 53.11 30 53.34C30 55.92 34.03 58.01 39 58.01C43.97 58.01 48 55.92 48 53.34C48 53.11 47.96 52.89 47.9 52.67C47.27 54.93 43.54 56.67 39 56.67ZM39 46C34.47 46 30.73 44.26 30.1 42C30.04 42.22 30 42.44 30 42.67C30 45.25 34.03 47.34 39 47.34C43.97 47.34 48 45.25 48 42.67C48 42.44 47.96 42.22 47.9 42C47.27 44.26 43.54 46 39 46ZM39 48.67C34.47 48.67 30.73 46.93 30.1 44.67C30.04 44.89 30 45.11 30 45.34C30 47.92 34.03 50.01 39 50.01C43.97 50.01 48 47.92 48 45.34C48 45.11 47.96 44.89 47.9 44.67C47.27 46.93 43.54 48.67 39 48.67ZM59.3 69.18H56.22L54.33 71.65L52.45 69.18H49.35L52.83 73.45L49.13 78H52.21L54.33 75.3L56.44 78H59.55L55.86 73.45L59.31 69.18H59.3ZM66.21 73.39C66.99 72.62 67.55 71.9 67.9 71.22C68.25 70.54 68.42 69.82 68.42 69.06C68.42 68.3 68.25 67.67 67.92 67.15C67.59 66.63 67.11 66.23 66.48 65.96C65.85 65.69 65.08 65.55 64.17 65.55C63.36 65.55 62.58 65.68 61.82 65.93C61.07 66.19 60.43 66.53 59.92 66.97L60.77 68.95C61.26 68.56 61.75 68.26 62.26 68.07C62.77 67.88 63.28 67.78 63.8 67.78C64.43 67.78 64.91 67.91 65.24 68.18C65.58 68.45 65.74 68.84 65.74 69.36C65.74 69.78 65.63 70.18 65.41 70.58C65.19 70.97 64.84 71.43 64.35 71.94L60.45 75.99V77.99H68.87V75.76H63.77L66.19 73.38L66.21 73.39Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "dep2_svg__filter0_ddi_4438_2775",
  x: 0,
  y: -12,
  width: 118,
  height: 120,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.808333 0 0 0 0 0.49443 0 0 0 0 0.0235764 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4438_2775"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 15
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow_4438_2775",
  result: "effect2_dropShadow_4438_2775"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect2_dropShadow_4438_2775",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect3_innerShadow_4438_2775"
})))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "dep2_svg__yellow",
  x1: 30.001,
  y1: 18,
  x2: 85.7529,
  y2: 82.4433,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.15625,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.265625,
  stopColor: "#FFDD9A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3125,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.46875,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.515625,
  stopColor: "#FFDD9A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.604167,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.875,
  stopColor: "#FFDD9A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.973958,
  stopColor: "white"
})))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "dep2_svg__gray",
  x1: 30.001,
  y1: 18,
  x2: 85.7529,
  y2: 82.4433,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.15625,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.265625,
  stopColor: "#C4C3DD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3125,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.46875,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.515625,
  stopColor: "#C4C3DD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.604167,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.875,
  stopColor: "#CECEE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.973958,
  stopColor: "white"
})))));
export { SvgDep2 as ReactComponent };
export default __webpack_public_path__ + "assets/icons/dep2.57741b.svg";